import { SAVE_NOTIFICATION_COUNT } from "../actions/actionTypes";

const initialState = {};

const notificationCount = (state, action) => {
  if (typeof state === "undefined") {
    return initialState;
  } else {
    if (action.type === SAVE_NOTIFICATION_COUNT) {
      return {
        ...state,
        ...action.payload,
      };
    } else {
      return state;
    }
  }
};

export default notificationCount;
